import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import SecretSeedModal from "../transaction/sharedComponent/secretSeedModal";
import { useLocation } from "react-router";
import {
  Hash,
  WalletCancelBuilder,
  WalletResultCode,
  WalletMA,
} from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { amountFormat } from "../../utils/WalletUtils";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../assets/images/clear.svg";
import AlertIcon from "../../assets/images/alert-icon.png";
import Modal from "@material-ui/core/Modal";
import { useStylesAlertModal } from "../AlertModal/style";

const PendingTransactionOverview = (props) => {
  const { t } = props;
  const [transactionOverview, setTransactionOverview] = useState(null);
  const { tx_hash } = useLocation().state;
  const { accounts, client, builders } = WalletMA.instance();
  const [readModeList, setReadModeList] = useState([]);
  const [error, setError] = useState(false);
  const [secretKeyModal, setSecretKeyModal] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [reCancelConfirm, setReCancelConfirm] = useState(false);
  const [isCancellation, setIsCancellation] = useState(false);
  const [isCancelMode, setIsCancelMode] = useState(false);
  const [mounted, setMounted] = useState(true);

  const getBuilder = () => {
    return builders.get("PENDING_TX");
  };
  const setBuilder = (builder) => {
    builders.set("PENDING_TX", builder);
  };

  useEffect(() => {
    console.log("PENDING_CANCEL:INIT:");
    if (!getBuilder()) initBuilder();
    if (tx_hash) {
      getPendingTransactionOverview(tx_hash);
    } else {
      console.log("tx_hash is Null.");
      props.history.push("/overview");
      return;
    }
    return () => {
      console.log("PENDING_CANCEL:DESTROY");
      setMounted(false);
      const builder = getBuilder();
      if (builder) {
        builder.clear();
        builders.delete("PENDING_TX");
      }
    };
  }, []);

  const initBuilder = async () => {
    const builder = new WalletCancelBuilder(client, accounts);
    await builder.setTransactionHash(new Hash(tx_hash));
    setBuilder(builder);
  };

  useEffect(() => {
    console.log("PENDIND_CANCEL:NEWBLOCK");
    if (tx_hash && getBuilder() && transactionOverview) {
      if (isCancelMode) {
        getCancelTransactionOverview();
      } else {
        getPendingTransactionOverview();
      }
    }
  }, [props.getSocketConnection.SocketConnection]);

  /**
   * Get pending transaction detail
   */
  const getPendingTransactionOverview = () => {
    if (getBuilder()) {
      const res = getBuilder().getOriginalTransactionOverview();
      if (mounted) {
        if (ErrorCheckUtil.resCodeCheck(res, false)) {
          if (res.data !== undefined) {
            setTransactionOverview(res.data);
            setError(false);
          } else {
            setError(true);
          }
        } else {
          setAlertMessage(ErrorCheckUtil.getLocaleMsg(res));
          setOpenAlertModal(true);
        }
      }
    } else {
      setTimeout(() => getPendingTransactionOverview(), 100);
    }
  };

  /**
   * get Cancel transaction detail
   */
  const getCancelTransactionOverview = () => {
    const res = getBuilder().getTransactionOverview();
    if (mounted) {
      if (ErrorCheckUtil.resCodeCheck(res, false)) {
        if (res.data !== undefined) {
          setTransactionOverview(res.data);
          setError(false);
        } else {
          setError(true);
        }
      } else if (res.code === WalletResultCode.ExistUnknownSecretKey) {
        transactionValidate();
      } else {
        setAlertMessage(ErrorCheckUtil.getLocaleMsg(res));
        setOpenAlertModal(true);
      }
    }
  };

  const transactionValidate = async () => {
    let readModeList = getBuilder().getReadOnlyAccount();
    if (readModeList.length > 0) {
      setReadModeList(readModeList);
      setSecretKeyModal(true);
    } else {
      setSecretKeyModal(false);
      setOpenAlertModal(false);

      if (isCancelMode) {
        const res = getBuilder().validate();
        if (ErrorCheckUtil.resCodeCheck(res, false)) {
          await sendToAgoraTransaction();
        } else if (res.code === WalletResultCode.Cancel_CancellationTx) {
          if (reCancelConfirm) {
            await sendToAgoraTransaction();
          } else {
            setIsCancellation(true);
            setAlertMessage(ErrorCheckUtil.getLocaleMsg(res));
            setOpenAlertModal(true);
          }
        } else {
          setAlertMessage(ErrorCheckUtil.getLocaleMsg(res));
          setOpenAlertModal(true);
        }
      } else {
        setIsCancelMode(true);
        getCancelTransactionOverview();
      }
    }
  };

  const secretCloseHandler = (value) => {
    if (value) {
      transactionValidate();
    }
    setSecretKeyModal(false);
  };

  const sendToAgoraTransaction = async () => {
    const b = getBuilder();
    if (b) {
      const tx_res = getBuilder().buildTransaction();
      if (ErrorCheckUtil.resCodeCheck(tx_res, false)) {
        const tx = tx_res.data;
        const res = await client.sendTransaction(tx);
        if (ErrorCheckUtil.resCodeCheck(res)) {
          props.history.push("/success");
        }
      }
    }
  };

  const handleAlertCloseModal = (e) => {
    const value = e.target.value;
    if (isCancellation) {
      if (value && value === "true") {
        sendToAgoraTransaction();
      } else {
        setIsCancellation(false);
        setOpenAlertModal(false);
      }
    } else {
      setOpenAlertModal(false);
      props.history.push("/overview");
    }
  };

  const previousClickHandler = () => {
    if (isCancelMode) {
      setIsCancelMode(false);
      getPendingTransactionOverview();
    } else {
      props.history.goBack();
    }
  };

  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg">
          <div className="ContHeader">
            <h1 className="OverviewTitle">
              {isCancelMode
                ? t("Cancellation_Transaction_Overview")
                : t("Pending_Transaction_Overview")}
            </h1>
          </div>
          <div className="ContHeader">
            <h3>{t("Senders_Detail")}</h3>
          </div>
          {/* Senders Detail section */}
          <div className="table-responsive trans-overview-page">
            <table className="table">
              <thead className="tableHead">
                <tr>
                  <th> {t("Address")}</th>
                  <th> {t("Amount")}</th>
                </tr>
              </thead>
              <tbody className="tablebody tbody1">
                {transactionOverview &&
                  transactionOverview.senders &&
                  transactionOverview.senders.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <div className="tooltipfull purpleText">
                          {info.address.toString()}
                          <div className="tooltiptextfull">
                            <p>{info.address.toString()}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        {amountFormat(info.amount)}
                        {" BOA"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="ContHeader">
            <h3>{t("Receivers_Detail")}</h3>
          </div>
          {/* Receivers Detail section */}
          <div className="table-responsive trans-overview-page">
            <table className="table">
              <thead className="tableHead">
                <tr>
                  <th> {t("Address")}</th>
                  <th> {t("Amount")}</th>
                </tr>
              </thead>
              <tbody className="tablebody tbody1">
                {transactionOverview &&
                  transactionOverview.receivers &&
                  transactionOverview.receivers.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <div className="tooltipfull purpleText">
                          {info.address.toString()}
                          <div className="tooltiptextfull">
                            <p>{info.address.toString()}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        {amountFormat(info.amount)}
                        {" BOA"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {transactionOverview &&
            transactionOverview.payload &&
            transactionOverview.payload.length > 0 && (
              <>
                <div className="ContHeader">
                  <h3>{t("Payload")}</h3>
                </div>
                <div className="data-value">
                  <p>
                    {transactionOverview &&
                      transactionOverview.payload &&
                      transactionOverview.payload.toString("base64")}
                  </p>
                </div>
              </>
            )}
          <div className="TransactionFee">
            <div>
              <h3 className="mb-0">{t("Transaction_Fee")}</h3>
              <p>
                {transactionOverview &&
                  transactionOverview.fee_tx &&
                  amountFormat(transactionOverview.fee_tx)}
                {" BOA"}
              </p>
            </div>
            <div />
          </div>
          {transactionOverview &&
            transactionOverview?.fee_freezing &&
            parseInt(transactionOverview.fee_freezing) > 0 && (
              <div className="TransactionFee">
                <div>
                  <h3 className="mb-0">{t("Freezing_Fee")}</h3>
                  <p>
                    {amountFormat(transactionOverview.fee_freezing)}
                    {" BOA"}
                  </p>
                </div>
                <div />
              </div>
            )}
          {transactionOverview &&
            transactionOverview.payload &&
            transactionOverview.payload.length > 0 && (
              <>
                <div className="TransactionFee">
                  <div>
                    <h3 className="mb-0">{t("Payload_Fee")}</h3>
                    <p>
                      {transactionOverview &&
                        transactionOverview.fee_payload &&
                        amountFormat(transactionOverview.fee_payload)}
                      {" BOA"}
                    </p>
                  </div>
                </div>
              </>
            )}
          <div className="wallet-note">
            <ul>
              {isCancelMode ? (
                <>
                  <li>{t("Create_Send_Transaction")}</li>
                  <li>{t("New_Cancellation_Transactions")}</li>
                </>
              ) : (
                <li>{t("Press_Cancellation_Transactions")}</li>
              )}
            </ul>
          </div>
          <div className="OverviewBtns">
            <button
              onClick={previousClickHandler}
              className="btn btn-default preBtnLarge"
            >
              {" "}
              {t("Previous")}
            </button>
            <button
              disabled={error}
              onClick={transactionValidate}
              className="btn btn-default cancelBtn"
            >
              {isCancelMode ? t("Confirm") : t("Cancel_Transaction")}
            </button>
          </div>
        </div>
        {/* Something went wrong or error alert message modal component */}
        <SecretSeedModal
          readModeList={readModeList}
          secretKeyModal={secretKeyModal}
          secretSeedModalCloseHandler={secretCloseHandler}
        />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={useStylesAlertModal().modal}
          open={openAlertModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openAlertModal}>
            <div className={`${useStylesAlertModal().paper} modalBg`}>
              <img
                alt="CloseIcon"
                className="ClearModalImg"
                src={CloseIcon}
                onClick={handleAlertCloseModal}
              />
              <div className="alert-icon">
                <img src={AlertIcon} alt="Alert icon" />
                <p>{alertMessage}</p>
              </div>
              <div className="modal_footer">
                <button
                  value={true}
                  className="btn btn-default senderBtn"
                  onClick={handleAlertCloseModal}
                >
                  {t("Ok")}
                </button>
                {isCancellation && (
                  <button
                    value={false}
                    className="btn btn-default senderBtn"
                    onClick={handleAlertCloseModal}
                  >
                    {t("No")}
                  </button>
                )}
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(PendingTransactionOverview))
);
